import React, { createContext, useContext, useMemo, useState } from 'react'

const LoginModalContext = createContext(null)

const useLoginModal = () => {
  const context = useContext(LoginModalContext)
  if (!context) {
    throw new Error('useLoginModal must be used within a LoginModalProvider')
  }
  return context
}

const LoginModalProvider = props => {
  const [loginModalVisible, setLoginModalVisible] = useState(null)

  const value = useMemo(() => ({ loginModalVisible, setLoginModalVisible }), [loginModalVisible])
  return <LoginModalContext.Provider value={value} {...props} />
}

export { LoginModalProvider, useLoginModal }
